<template>
  <div>
    <banner :img="bannerImg" title="精典案例" />
    <div class="box4">
      <div class="box-flex">
        <div class="right">
          <div
            style="display: flex;border-bottom: 1px solid #e0e0e0;padding: 20px;cursor: pointer;"
            v-for="(item, index) in newList"
            :key="index"
            @click="changeUrl(item)"
          >
            <div>
              <img
                style="width: 100px;height: 75px;object-fit: contain; margin-right: 20px;"
                :src="item.img"
                alt=""
              />
            </div>
            <div class="time">
              <div class="day">{{ item.day }}</div>
              <div class="month">{{ item.month }}</div>
            </div>
            <div class="content">
              <div class="title">{{ item.title }}</div>
              <div class="text">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
import newList from './data.js'
export default {
  components: {
    Banner,
  },
  data() {
    return {
      bannerImg: require("../assets/img/aboutUs/banner.png"),
      newList:newList
    };
  },
  methods: {
    changeUrl(item) {
      window.open(item.url);
    },
  },
};
</script>
<style lang="scss" scoped>
.box4 {
  width: 1400px;
  margin: 100px auto;
  .box-flex {
    display: flex;
    .right {
      width: 100%;
      .content {
        flex-shrink: 0;
        margin-left: 10px;
        .title {
          font-size: 18px;
        }
        .text {
          margin-top: 8px;
          color: #686868;
          line-height: 24px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          width: 1160px;
        }
      }

      .time {
        flex-shrink: 0;
        text-align: center;
        .day {
          font-size: 32px;
          font-weight: bold;
          color: #3a4354;
        }
        .month {
          margin-top: 10px;
          font-size: 20px;
          color: #3a4354;
        }
      }
    }
  }
}
</style>
